import { Drawer, Empty, Tree } from "antd";
import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { authenticateToken } from "../../../utils/auth";
import Loading from "../../common/Loader";
import { responseNotification } from "../../../utils/notify";
import CategoryLayout from "../Layout";
import _ from "lodash";
import CategoryHeader from "../Layout/topHeader";
import { useSelector } from "react-redux";
import AddCategory from "../AddCategory";
const { DirectoryTree } = Tree;

const SubCategoryList = () => {
  const { categoryInfo } = useSelector((state) => (state as any)?.authReducer);
  const [type, setType] = useState<string>("JC_MART");
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(undefined);
  const [categoryId, setCategoryId] = useState<any>();
  const [categoryName, setCategoryName] = useState<any>();
  const [selectedCategoryForEdit, setSelectedCategoryForEdit] =
    useState(undefined);

  const [singleCategoryInfo, setSingleCategoryInfo] = useState({
    loading: false,
    data: null,
  });
  const [categoryData, setCategoryData] = useState({
    loading: false,
    data: null,
  });

  const fetchCategoryDetails = useCallback(() => {
    setSingleCategoryInfo({ loading: true, data: undefined });
    axios
      .get(
        `${process.env.REACT_APP_CATALOG_READER_API}/admin/category/detail?categoryId=${categoryInfo?.id}`,
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((data) => {
        if (data.status === 200) {
          setSingleCategoryInfo({
            loading: false,
            data: data?.data?.category,
          });
        } else {
          setSingleCategoryInfo({ loading: false, data: null });
          responseNotification(
            data.statusText || "something went wrong",
            "error"
          );
        }
      })
      .catch((err) => {
        setSingleCategoryInfo({ loading: false, data: null });

        console.log(err);
      });
  }, []);

  // Category List By Parent ID
  const getSubCategory = useCallback(() => {
    setCategoryData({ loading: true, data: undefined });
    axios
      .get(
        `${process.env.REACT_APP_CATALOG_READER_API}/admin/category/child-category-by-parent?categoryId=${categoryInfo?.id}`,
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((data) => {
        if (data.status === 200) {
          setCategoryData({
            loading: false,
            data: data?.data,
          });
        } else {
          setCategoryData({ loading: false, data: null });
          responseNotification(
            data.statusText || "something went wrong",
            "error"
          );
        }
      })
      .catch((err) => {
        setCategoryData({ loading: false, data: null });

        console.log(err);
      });
  }, []);

  useEffect(() => {
    getSubCategory();
    fetchCategoryDetails();
  }, [fetchCategoryDetails, getSubCategory]);

  const changePosition = async (pos, node) => {
    setLoading(true);

    let curr;
    let item;

    categoryData?.data?.categories?.find((category, i) => {
      if (category?.id === node?.key) {
        curr = i;
        item = category;
      }
    });

    const formated =
      curr !== pos &&
      _.concat(
        curr < pos
          ? categoryData?.data?.categories
              ?.filter((_, i) => i !== curr)
              ?.slice(0, pos - 1)
          : categoryData?.data?.categories?.slice(0, pos),
        item,
        curr > pos
          ? categoryData?.data?.categories
              ?.filter((_, i) => i !== curr)
              ?.slice(pos, categoryData?.data?.categories?.length - 1)
          : categoryData?.data?.categories?.slice(
              pos,
              categoryData?.data?.categories?.length
            )
      )?.map((item, i) => ({
        categoryId: item?.id,
        position: i + 1,
      }));

    if (formated) {
      await fetch(
        `${process.env.REACT_APP_CATALOG_WRITER_API}/category/position`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            categories: formated,
          }),
        }
      )
        .then((res) => res.json())
        .then((res) => {
          setLoading(false);

          if (res.statusCode === 200) {
            getSubCategory();
            responseNotification("Position Updated Successfully", "success");
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    }
  };

  // const onDelete = async (id: any) => {
  //   setConfirmLoading(id);

  //   await fetch(
  //     `${process.env.REACT_APP_CATALOG_WRITER_API}/category?categoryId=${
  //       categoryId ? categoryId : categoryInfo?.id
  //     }`,
  //     {
  //       method: "DELETE",
  //       headers: {
  //         Authorization: `Bearer ${authenticateToken()}`,
  //         "Content-Type": "application/json",
  //       },
  //       // body: JSON.stringify(),
  //     }
  //   )
  //     .then((res) => res.json())
  //     .then((res) => {
  //       setConfirmLoading(undefined);
  //       if (res.statusCode === 200) {
  //         responseNotification("Category Deleted Successfully", "success");
  //         history.push("/global-categories");
  //       } else if (res.status === 500) {
  //         responseNotification("Internal server error", "error");
  //       } else {
  //         responseNotification(res.message || "something wrong", "warning");
  //       }
  //     })
  //     .catch((err) => {
  //       responseNotification(`${"Internal server error"} ${err}`, "error");
  //       console.error("err", err);
  //     });
  // };

  const onClose = () => {
    setSelectedCategoryForEdit(null);
    getSubCategory();
  };

  return (
    <React.Fragment>
      <CategoryLayout categoryId={categoryInfo?.id as string}>
        <div className="product-list-item-area white-bg">
          <CategoryHeader leftarea={"Category Details"} rightarea={""} />

          <div className="details-area">
            <div className="details-area_">
              <div className="pt-4">
                <div className="inner-body">
                  <div className="single">
                    <span className="info-name">Category Name</span>
                    <span className="info-desc">{categoryInfo?.title}</span>
                  </div>

                  <div className="single">
                    <span className="info-name">Slug</span>
                    <span className="info-desc">{categoryInfo?.slug}</span>
                  </div>
                  {/* {!categoryData?.data?.categories?.length ? (
                    <div className="single mt-5">
                      <span className="info-name">Action</span>
                      <span className="info-desc">
                        <Popconfirm
                          title="Are you sure to delete this Category Permanently?"
                          onConfirm={(val) => onDelete(val)}
                          onVisibleChange={() => console.log("visible change")}
                        >
                          <Button danger type="primary">
                            <DeleteFilled /> Delete Permanently
                          </Button>
                        </Popconfirm>
                      </span>
                    </div>
                  ) : (
                    undefined
                  )} */}
                </div>
              </div>
            </div>

            <div className="pt-3">
              {categoryData?.loading || loading === true ? (
                <Loading />
              ) : (
                <div className="product-table-area mt-3">
                  <h4 className="title">Sub Categories</h4>
                  {categoryData?.data?.categories?.length ? (
                    <DirectoryTree
                      height={600}
                      multiple
                      showIcon={false}
                      draggable
                      treeData={categoryData?.data?.categories?.map(
                        (category) => ({
                          title: category?.title,
                          key: category?.id,
                          // children: category?.categories?.map((child) => ({
                          //   title: child?.categories?.title,
                          //   key: child?.categories?.id,
                          // })),
                        })
                      )}
                      onDrop={(e) => {
                        changePosition(e.dropPosition, e.dragNode);
                      }}
                      onRightClick={(val) => {
                        setCategoryId(val?.node?.key);
                        setCategoryName(val?.node?.title);
                        setVisible(val?.node?.key);
                      }}
                      onSelect={(val) => {
                        console.log(val);
                        setSelectedCategoryForEdit(val);
                      }}
                    />
                  ) : (
                    <Empty />
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </CategoryLayout>

      <Drawer
        title={selectedCategoryForEdit ? "Edit Category" : ""}
        width={600}
        onClose={() => {
          setSelectedCategoryForEdit(null);
        }}
        visible={selectedCategoryForEdit}
        bodyStyle={{ paddingBottom: 80 }}
        footer={
          <div
            style={{
              textAlign: "right",
            }}
          ></div>
        }
      >
        {selectedCategoryForEdit ? (
          <AddCategory
            visibleData={selectedCategoryForEdit}
            onCloseMethod={onClose}
          />
        ) : undefined}
      </Drawer>
    </React.Fragment>
  );
};

export default SubCategoryList;
